import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './common/SafeIcon';

const { FiMessageCircle, FiChevronRight } = FiIcons;

const App = () => {
  const steps = [
    {
      id: 'GET STARTED',
      title: 'Join the WhatsApp Community',
      description: 'Connect with 5,000+ data professionals, get daily tips, and stay updated with the latest AI trends and Power BI insights.',
      buttonText: 'Join This Whatsapp Group to Dowload The Ebook!',
      buttonColor: 'bg-[#3b82f6]',
      hoverColor: 'hover:bg-[#2563eb]',
      icon: FiMessageCircle,
      action: () => window.open('https://chat.whatsapp.com/JlZh21pJT8D3G4HjBWTMNi', '_blank')
    }
  ];

  return (
    <div className="min-h-screen flex flex-col bg-[#0b0f1a]">
      {/* Header */}
      <header className="bg-white w-full border-b border-gray-200 py-3 px-4 md:px-8 shadow-sm">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-2">
            <img 
              src="https://media-manager-c.questera.ai/greta-media/d1e1f795f547d188310881b3e1dfad84afccd53626664f205958a3becb1b00f4f5d96fb34b3d15472c5f30d572e92287/images/aW1hZ2UvcG5n/8bb40739d18b978a054bac271b6f4417.png" 
              alt="Yinguru Academy Logo" 
              className="h-10 md:h-12 w-auto object-contain" 
            />
          </div>
          <div className="text-center flex-1">
            <h1 className="text-lg md:text-2xl font-black text-gray-900 tracking-tighter">
              Yinguru Academy
            </h1>
            <p className="text-[9px] md:text-xs font-bold text-red-600 uppercase tracking-[0.2em]">
              UNLEASH THE POWER OF UNSEEN
            </p>
          </div>
          <div className="hidden md:block w-[100px]"></div> {/* Spacer to keep title centered */}
        </div>
      </header>

      <main className="flex-grow flex flex-col justify-center">
        <section className="pt-20 pb-12 px-4 text-center">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-4xl md:text-6xl font-black mb-6 tracking-tight text-white">
              🚀 Master Power BI <span className="text-[#facc15]">With Experts</span>
            </h2>
            <p className="text-xl md:text-2xl text-white/70 font-medium max-w-2xl mx-auto">
              Join our exclusive community to accelerate your data career.
            </p>
          </motion.div>
        </section>

        <section className="max-w-4xl mx-auto px-4 pb-24 w-full">
          <div className="space-y-8">
            {steps.map((step, index) => (
              <motion.div
                key={step.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2, duration: 0.5 }}
                className="dark-gradient-card rounded-3xl p-8 relative overflow-hidden group"
              >
                <div className="absolute top-0 left-0">
                  <div className="step-pill px-6 py-2 rounded-br-2xl uppercase">
                    {step.id}
                  </div>
                </div>

                <div className="mt-6 flex flex-col md:flex-row md:items-center justify-between gap-6 relative z-10">
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold mb-3 flex items-center gap-3 text-white">
                      <SafeIcon icon={step.icon} className="text-[#facc15]" />
                      {step.title}
                    </h3>
                    <p className="text-white/70 leading-relaxed text-lg">
                      {step.description}
                    </p>
                  </div>
                  <div className="flex-shrink-0">
                    <button
                      onClick={step.action}
                      className={`${step.buttonColor} ${step.hoverColor} text-white font-bold px-8 py-5 rounded-2xl flex items-center justify-center gap-3 transition-all duration-300 transform hover:scale-105 shadow-xl group-hover:shadow-2xl text-lg text-center`}
                    >
                      <span className="max-w-[300px]">{step.buttonText}</span>
                      <FiChevronRight className="group-hover:translate-x-1 transition-transform flex-shrink-0" />
                    </button>
                  </div>
                </div>

                <div className="absolute -right-4 -bottom-4 opacity-5 group-hover:opacity-10 transition-opacity">
                  <SafeIcon icon={step.icon} className="text-[12rem] text-white" />
                </div>
              </motion.div>
            ))}
          </div>
        </section>
      </main>

      <footer className="bg-black py-12 px-4 border-t border-white/5">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <div className="w-8 h-8 bg-white/10 rounded flex items-center justify-center">
              <span className="text-white font-black text-sm italic">Y</span>
            </div>
            <p className="text-white/50 text-sm font-medium">
              © 2026 Yinguru Academy. All Rights Reserved.
            </p>
          </div>
          <div className="flex gap-8">
            <a href="#" className="text-white/50 hover:text-white text-xs uppercase tracking-widest transition-colors font-bold">Privacy Policy</a>
            <a href="#" className="text-white/50 hover:text-white text-xs uppercase tracking-widest transition-colors font-bold">Terms of Service</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;